// extracted by mini-css-extract-plugin
export default {"root":"User_root__sGybX","avatar":"User_avatar__4G9x-","name":"User_name__L-ACC","email":"User_email__J2U6o"};